/**
 * External Links
 */
export const EXTERNAL_LINKS = {
  LINKEDIN: 'https://www.linkedin.com/company/trypillian/about/',
  X: 'https://x.com/TrypillianTech',
} as const;

/**
 * Social Media Links
 */
export const SOCIAL_LINKS = {
  LINKEDIN: EXTERNAL_LINKS.LINKEDIN,
  X: EXTERNAL_LINKS.X,
} as const;
